import React, { Component } from 'react';
import './downLoadDict.scss';

class DownLoadDict extends Component {
  constructor(props, context){
    super(props)
    this.state = {
      show: true
    }
  }
  handleChange() {
    this.setState({
      show: !this.state.show
    })
  }
  openDict (){
    window.location.href = 'http://cidian.youdao.com/m/d'
  }
  render() {
    return (
      this.state.show && <div className="down_load_dict">
        <div className="contact">
          <img src="http://ydschool-online.nos.netease.com/1573528564193img_logo.png" className="logo" alt="logo"/>
          <img src="http://ydschool-online.nos.netease.com/1573528581546btn_wap_close_ad.png" className="close" alt="close" onClick={()=>this.handleChange()}/>
          <div className="down" onClick={()=>this.openDict()}>进入学习</div>
        </div>
      </div>
    );
  }
}

export default DownLoadDict;
